import * as S from './styles';

export function RevokedReasons() {
  return (
    <div>
      <p>Total de pedidos recusados por:</p>

      <S.List>
        <li>Desconto/ Parc. Não Permitida</li>
        <li>Produto Com Defeito/ WFA</li>
        <li>Produto De Troca</li>
        <li>Produto Reservado</li>
        <li>Produto em Malinha</li>
        <li>Produto em Transferência/ Remanejo</li>
        <li>Marketing/ Seeding</li>
        <li>Voucher Não Aceito</li>
      </S.List>
    </div>
  );
}
